import mapValues from 'lodash/mapValues'
import { groupDiagnosis } from '../../mappers'
import { createRowSlotsByHealthProcedureType } from '../../mapValues'
import { groupByYear } from '~/utils'
import { IHealthProcedures, ITimelineGeneral } from '~/interfaces'

export const mapperTimelineViewByYearsFrom = (
  healthProcedures: IHealthProcedures[]
): ITimelineGeneral.IYearTimelineData => {
  const healthProceduresWithDiagnosis = groupDiagnosis(healthProcedures)
  const groupedByYear = groupByYear(healthProceduresWithDiagnosis)

  const groupedYearsStructured = mapValues(
    groupedByYear,
    (groupedHealthProcedure: IHealthProcedures[], key: string) => {
      const groupByType = createRowSlotsByHealthProcedureType(groupedHealthProcedure)

      return {
        id: key,
        date: new Date(Number(key), 0, 1).toISOString(),
        yearRowSlotsTotal: groupedHealthProcedure.length,
        rowSlots: Object.values(groupByType) as ITimelineGeneral.ISlot[]
      }
    }
  ) as ITimelineGeneral.IYearsRowSlotsWrapper

  return {
    timelineId: new Date(healthProcedures[0]?.startDate).getTime(),
    years: Object.values(groupedYearsStructured).reverse()
  }
}
